<div class="forecast-header forecast-header-custom mb-3">
  <div *ngFor="let item of dataRows" class="">
    <div class="card mb-0 h-100">
      <div class="card-body card-body-custom">
        <div class="row">
          <div class="col mt-0">
            <a
              (click)="isInteraction && onClickItem(item.key)"
              class="text-muted"
              [class.text-decoration-none]="isHiddenTextDecoration(item?.name)"
              [class.k-cursor-default]="isHiddenTextDecoration(item?.name)"
            >
              <h5 class="card-title text-uppercase">
                <span [ngSwitch]="item?.name">
                  {{ item?.name }}
                  <span *ngSwitchCase="SummaryItemNameEnum.AmazonItems">
                    {{ SummaryItemStatusEnum.OutOfStock }}
                  </span>
                  <span *ngSwitchCase="SummaryItemNameEnum.WarehouseItems">
                    {{ SummaryItemStatusEnum.OutOfStock }}
                  </span>
                  <span *ngSwitchCase="SummaryItemNameEnum.NewItems">
                    {{ SummaryItemStatusEnum.Lats30Days }}
                  </span>
                </span>
              </h5>
            </a>
          </div>

          <div class="col-auto">
            <div class="stat-custom d-flex align-items-center justify-content-center">
              <div [innerHTML]="getIconNew(item?.name)" class="item-center"></div> 
            </div>
          </div>
        </div>
        <h1 class="mt-1 mb-3 price-custom">
          {{
            item?.isMoney
              ? (item.total
                | currency : displayCurrency.code : displayCurrency.symbol : '1.2')
              : (item?.total | number : 0)
          }}
        </h1>
        <span class="mr-1" [ngClass]="{
          'blue-pale': [
            SummaryItemNameEnum.AmazonItems,
            SummaryItemNameEnum.ItemsOutOfStock,
            SummaryItemNameEnum.SuggestedPurchaseOrders
          ].includes(item?.name),
          'red-pale': [
            SummaryItemNameEnum.NoSuppliersAssigned,
            SummaryItemNameEnum.TotalUnitsOnSuggestedPurchaseOrders
          ].includes(item?.name),
          'green-pale': [
            SummaryItemNameEnum.NewItems,
            SummaryItemNameEnum.WarehouseItems,
            SummaryItemNameEnum.TotalCostOfSuggestedPurchaseOrders,
            SummaryItemNameEnum.TotalItemsOnSuggestedPurchaseOrders,
            SummaryItemNameEnum.TotalEstimatedStorageFees
          ].includes(item?.name)
        }">
          {{ item.different }}%
        </span>
        <span> vs last week</span>
      </div>
    </div>
  </div>
</div>
